export default {
  Information_information_detail: '10Web-Information details page',
  Information_information_show: '1001Web-Display course details page',
}
